import React from 'react'
import { useHistory } from 'react-router-dom'

function Messages() {
  let { location } = useHistory()

  return (
    <div
      style={{
        color: `${location.pathname === '/messages' ? '#2ACC96' : 'white'}`,
      }}
    >
      Messages
    </div>
  )
}

export default Messages
